import Products from './Products';
import TariffGroup from './TariffGroup';
import SaleOrigin from './SaleOrigin';
import Coupon from './Coupon';
import DirectLink from './DirectLink';
import PaymentMethod from './PaymentMethod';
import AppTag from './AppTag';
import SaleTag from './SaleTag';

export default {
    PaymentMethod,
    DirectLink,
    Coupon,
    SaleOrigin,
    TariffGroup,
    Products,
    AppTag,
    SaleTag,
};
